import React from 'react';
import { Box, Typography, Grid, Link, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#000',
        color: '#fff',
        py: 6,
        px: { xs: 2, sm: 4, md: 8 },
      }}
    >
  {/*     <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            MyCompany
          </Typography>
          <Typography variant="body2" sx={{ lineHeight: 1.8 }}>
            Creamos experiencias únicas en peluquería y estilo. Nuestro objetivo es
            brindar el mejor servicio adaptado a tus necesidades.
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Quick Links
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Link href="#" underline="hover" color="inherit">Inicio</Link>
            <Link href="#" underline="hover" color="inherit">Servicios</Link>
            <Link href="#" underline="hover" color="inherit">Galería</Link>
            <Link href="#" underline="hover" color="inherit">Contacto</Link>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Contacto
          </Typography>
          <Typography variant="body2" sx={{ lineHeight: 1.8 }}>
            Email: info@mycompany.com
          </Typography>
          <Typography variant="body2" sx={{ lineHeight: 1.8 }}>
            Tel: +54 123 456 789
          </Typography>
          <Box sx={{ mt: 2 }}>
            <IconButton aria-label="Facebook" sx={{ color: '#fff' }}>
              <FacebookIcon />
            </IconButton>
            <IconButton aria-label="Instagram" sx={{ color: '#fff' }}>
              <InstagramIcon />
            </IconButton>
            <IconButton aria-label="Twitter" sx={{ color: '#fff' }}>
              <TwitterIcon />
            </IconButton>
            <IconButton aria-label="LinkedIn" sx={{ color: '#fff' }}>
              <LinkedInIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
 */}
      {/* Línea divisoria */}
      <Box
        sx={{
          borderTop: '1px solid #444',
          mt: 6,
          pt: 3,
          textAlign: 'center',
        }}
      >
        <Typography variant="body2">
          © {new Date().getFullYear()} Estudio Isaac. Todos los derechos reservados.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
